import { useEffect }          from 'react';
import { store }              from 'index'
import { groupUrl }           from 'utils/constants'
import { GET_USER_INFO_SAGA } from 'actions';

const useGetUserInfo = () => {

    const state        = store.getState();
    const { userInfo } = state.data;

    useEffect(() => {
        if ( !groupUrl && userInfo.userEmail.length === 0 ) {
            store.dispatch(GET_USER_INFO_SAGA());
         }
      },[ userInfo])
    
}
export default useGetUserInfo;

